import CommonActionType from './action/common';
export enum CommonFetchActionType {
  START_FETCH = 'START_FETCH',
  FETCH_SUCCESS = 'FETCH_SUCCESS',
  FETCH_FAILED = 'FETCH_FAILED',
}
export default {
  ...CommonActionType,
  ...CommonFetchActionType,
};
